
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 19 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M14.769.895V2.75h.862V0h-2.404v.895h1.542zm-11.521 0H4.79V.001H2.386v2.75h.862V.894zm0 11.392v-1.752h-.862v2.647H4.79v-.895H3.248zm11.521 0h-1.542v.895h2.404v-2.647h-.862v1.752z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M15.624 15.172c-2.579-.617-4.98-1.158-3.817-3.436 3.539-6.922.938-10.623-2.798-10.623-3.81 0-6.348 3.843-2.8 10.623 1.198 2.29-1.294 2.828-3.817 3.436-2.577.617-2.379.269-2.379 2.827h17.993c-.002-2.558.196-2.21-2.382-2.827z"}})])
          )
        }
      }
    